import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX2Y2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 512,
	height: 512,
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M459.265 100.353C420.038 62.0229 366.378 38.4 307.2 38.4C187.023 38.4 89.6 135.823 89.6 256C89.6 376.177 187.023 473.6 307.2 473.6C366.377 473.6 420.038 449.977 459.265 411.647C412.474 472.661 338.831 512 256 512C114.615 512 0 397.385 0 256C0 114.615 114.615 0 256 0C338.831 0 412.474 39.339 459.265 100.353Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M144.588 380.518C175.97 411.182 218.898 430.08 266.24 430.08C362.382 430.08 440.32 352.142 440.32 256C440.32 159.858 362.382 81.92 266.24 81.92C218.898 81.92 175.97 100.818 144.588 131.482C182.021 82.6712 240.935 51.2 307.2 51.2C420.308 51.2 512 142.892 512 256C512 369.108 420.308 460.8 307.2 460.8C240.935 460.8 182.021 429.329 144.588 380.518Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M409.6 256C409.6 340.831 340.831 409.6 256 409.6C171.169 409.6 102.4 340.831 102.4 256C102.4 171.169 171.169 102.4 256 102.4C340.831 102.4 409.6 171.169 409.6 256ZM358.4 256C358.4 312.554 312.554 358.4 256 358.4C199.446 358.4 153.6 312.554 153.6 256C153.6 199.446 199.446 153.6 256 153.6C312.554 153.6 358.4 199.446 358.4 256Z",
			fill: "currentColor"
		})
	]
});
export default SvgX2Y2;
